import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            id: 0,
            acronym: '',
            name: '',
            office: { id: 0 },
            isActive: true,
            isOutsourced: false,
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        return utilities.toPayload(obj);
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/Area.js